/**
 * Préremplissage one-shot des créneaux livraison depuis les horaires boutique.
 * Aucun découpage : chaque plage ouverte → un candidat fenêtre complète.
 */

const JOUR_NAME_TO_NUM = {
  LUNDI: 1,
  MARDI: 2,
  MERCREDI: 3,
  JEUDI: 4,
  VENDREDI: 5,
  SAMEDI: 6,
  DIMANCHE: 0,
};

function normalizeHm(value) {
  return String(value || '').trim().slice(0, 5);
}

export function creneauIdentityKey({ jourSemaine, heureDebut, heureFin }) {
  return `${Number(jourSemaine)}|${normalizeHm(heureDebut)}|${normalizeHm(heureFin)}`;
}

/**
 * @param {Array<{ jour: string, creneaux?: Array }>} horairesFrontend
 * @returns {Array<{ jourSemaine: number, heureDebut: string, heureFin: string, capacite: null }>}
 */
export function buildLivraisonCreneauxCandidatesFromHoraires(horairesFrontend) {
  const candidates = [];
  if (!Array.isArray(horairesFrontend)) return candidates;

  for (const day of horairesFrontend) {
    const jourSemaine = JOUR_NAME_TO_NUM[day?.jour];
    if (jourSemaine === undefined) continue;
    const slots = Array.isArray(day?.creneaux) ? day.creneaux : [];
    for (const slot of slots) {
      if (!slot?.actif) continue;
      const heureDebut = normalizeHm(slot.heureDebut);
      const heureFin = normalizeHm(slot.heureFin);
      if (!heureDebut || !heureFin) continue;
      candidates.push({
        jourSemaine,
        heureDebut,
        heureFin,
        capacite: null,
      });
    }
  }

  return candidates;
}

/**
 * Add-only : skip doublons exacts jour+début+fin (existants ou déjà dans le lot).
 */
export function partitionLivraisonPrefill(candidates, existingCreneaux = []) {
  const seen = new Set(
    (Array.isArray(existingCreneaux) ? existingCreneaux : []).map(creneauIdentityKey),
  );
  const toAdd = [];
  let skipped = 0;

  for (const candidate of Array.isArray(candidates) ? candidates : []) {
    const key = creneauIdentityKey(candidate);
    if (seen.has(key)) {
      skipped += 1;
      continue;
    }
    seen.add(key);
    toAdd.push(candidate);
  }

  return { toAdd, skipped };
}
